/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectDto } from '../../models/backend-project-dto';
import { BackendProjectRequestDto } from '../../models/backend-project-request-dto';

export interface ProjectsProjectsUpdate$FormData$Params {
  id: number;
  body?: BackendProjectRequestDto;
}

export function projectsProjectsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectDto>;
    }),
  );
}

projectsProjectsUpdate$FormData.PATH = '/api/projects/projects/{id}/';
